export enum AssetEditPermissionAction {
	EDIT_DASHBOARD = 'editDashboard',
	CREATE_METRIC = 'createMetric',
	CREATE_FILTER = 'createFilter',
	MANAGE_DRIVERS = 'manageDrivers',
	MANAGE_STUDIO_ALERTS = 'manageStudioAlerts',
	MANAGE_SETTINGS = 'manageSettings'
}

